import React, { useState, useContext } from 'react';
import { string } from 'prop-types';
import { useStoreId, ExperienceContext } from '@thd-nucleus/experience-context';
import { useProduct } from '@thd-nucleus/data-sources';
import { Row, Col } from '@thd-olt-component-react/grid';
import { Overlay } from '@thd-olt-component-react/overlay';
import { DisclaimerMessageContent } from './DisclaimerMessageContent';
import './disclaimer-message.scss';

const DisclaimerMessage = ({ itemId }) => {
  const [open, setOpen] = useState(false);
  const { channel } = useContext(ExperienceContext);
  const storeId = useStoreId();
  const { data, loading, error } = useProduct({
    itemId,
    storeId,
    domains: ['info']
  });

  if (!data || loading || (error && !data)) {
    return null;
  }

  const {
    info = {}
  } = data?.product || {};

  if (!info?.forProfessionalUseOnly) {
    return null;
  }
  const openLegalDisclaimer = () => {
    setOpen(true);
  };
  return (
    <div className="disclaimer-message__wrapper disclaimer-message__text disclaimer-message__color">
      <div className="alert-inline alert-inline--warning">
        <span className="alert-inline__message">
          <span className="alert-inline__title">
            <strong>
              This product is for professional and commercial use only. <br />
            </strong>
          </span>
          {'Please review our '}
          <span
            className="u__default-link"
            tabIndex={0}
            role="link"
            onClick={openLegalDisclaimer}
          >
            legal disclaimer
          </span>
          <Overlay
            closeButton
            open={open}
            medium
            onClose={() => setOpen(false)}
            header="Legal Disclaimer"
          >
            <DisclaimerMessageContent
              channel={channel}
            />
          </Overlay>
          {' before purchasing this product.'}<br />
        </span>
      </div>
    </div>
  );
};

DisclaimerMessage.displayName = 'DisclaimerMessage';

DisclaimerMessage.propTypes = {
  itemId: string
};

DisclaimerMessage.defaultProps = {
  itemId: null
};

export { DisclaimerMessage };
